// // Global quantity selector handler
// document.addEventListener("DOMContentLoaded", function () {
//   // Find all forms that might have quantity selectors
//   const productForms = document.querySelectorAll(
//     'form[data-type="add-to-cart-form"]'
//   );

//   productForms.forEach((form) => {
//     // Find quantity inputs associated with this form
//     const formId = form.id;
//     const quantityInputs = document.querySelectorAll(
//       `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`
//     );

//     if (quantityInputs.length === 0) return;

//     // Override form submission
//     form.addEventListener("submit", function (e) {
//       // Get the first visible quantity input
//       const activeQuantityInput = quantityInputs[0];
//       const quantity = parseInt(activeQuantityInput.value) || 1;

//       // Remove any existing hidden quantity inputs
//       form
//         .querySelectorAll('input[type="hidden"][name="quantity"]')
//         .forEach((input) => {
//           input.remove();
//         });

//       // Create a new hidden input with the current quantity
//       const qtyInput = document.createElement("input");
//       qtyInput.type = "hidden";
//       qtyInput.name = "quantity";
//       qtyInput.value = quantity;

//       // Add the hidden input to the form
//       form.appendChild(qtyInput);
//     });
//   });

//   // Handle responsive product titles
//   function handleResponsiveProductTitles() {
//     const productTitles = document.querySelectorAll(
//       ".shop-product-title[data-font-size][data-mobile-font-size]"
//     );

//     productTitles.forEach((title) => {
//       function adjustTitleFontSize() {
//         const desktopSize = title.getAttribute("data-font-size");
//         const mobileSize = title.getAttribute("data-mobile-font-size");

//         if (window.innerWidth <= 767) {
//           title.style.setProperty("font-size", `${mobileSize}px`, "important");
//         } else {
//           title.style.setProperty("font-size", `${desktopSize}px`, "important");
//         }
//       }

//       // Run immediately
//       adjustTitleFontSize();

//       // Add resize event listener if not already added
//       if (!title.hasAttribute("data-resize-listener-added")) {
//         window.addEventListener("resize", adjustTitleFontSize);
//         title.setAttribute("data-resize-listener-added", "true");
//       }
//     });
//   }

//   // Initialize responsive product titles
//   handleResponsiveProductTitles();

//   // Handle FAQ accordions
//   function initFaqAccordions() {
//     const faqContainers = document.querySelectorAll(".product-faq");

//     faqContainers.forEach((faqContainer) => {
//       const faqId = faqContainer.id;
//       if (!faqId) return;

//       const faqItems = faqContainer.querySelectorAll(".faq-item");
//       const innerFaqContainer = faqContainer.querySelector(".faq-container");
//       const isAccordion =
//         innerFaqContainer &&
//         innerFaqContainer.getAttribute("data-accordion") === "true";

//       faqItems.forEach((item) => {
//         const question = item.querySelector(".faq-question");
//         if (!question) return;

//         // Only add click listener if it doesn't already have one
//         if (!question.hasAttribute("data-click-listener-added")) {
//           question.setAttribute("data-click-listener-added", "true");

//           question.addEventListener("click", () => {
//             const isActive = item.classList.contains("active");

//             // Close all other items first if accordion mode is enabled
//             if (isAccordion && !isActive) {
//               faqItems.forEach((otherItem) => {
//                 otherItem.classList.remove("active");
//               });
//             }

//             // Toggle the clicked item
//             item.classList.toggle("active");
//           });
//         }
//       });
//     });
//   }

//   // Initialize FAQ accordions
//   initFaqAccordions();
// });

// // Other product details JavaScript can go here

// document.addEventListener("DOMContentLoaded", function () {
//   setTimeout(function () {
//     document.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
//       bar.addEventListener("click", function () {
//         // Get pricing values
//         const pricingContainer = bar.querySelector(
//           ".kaching-bundles__bar-pricing"
//         );
//         const priceElement = pricingContainer.querySelector(
//           ".kaching-bundles__bar-price"
//         );
//         const fullPriceElement = pricingContainer.querySelector(
//           ".kaching-bundles__bar-full-price"
//         );

//         const price = priceElement ? priceElement.textContent.trim() : null;
//         const fullPrice = fullPriceElement
//           ? fullPriceElement.textContent.trim()
//           : null;

//         // Find parent product info block
//         const productInfo = bar.closest(".shop-product-info");

//         if (productInfo && price && fullPrice) {
//           const buttonTextContainer = productInfo.querySelector(
//             ".shop-add-to-cart-button .button-text"
//           );
//           if (buttonTextContainer) {
//             setTimeout(function () {
//               buttonTextContainer.innerHTML = `Add to Cart - ${price} <span class="compare-price">${fullPrice}</span>`;
//             }, 50);
//           }
//         }
//       });
//     });
//   }, 1000);
// });



// Global quantity selector handler
document.addEventListener("DOMContentLoaded", function () {
  // Find all forms that might have quantity selectors
  const productForms = document.querySelectorAll(
    'form[data-type="add-to-cart-form"]'
  );

  productForms.forEach((form) => {
    // Find quantity inputs associated with this form
    const formId = form.id;
    const quantityInputs = document.querySelectorAll(
      `input[name="quantity"][form="${formId}"], .modern-quantity-selector .quantity-input[form="${formId}"]`
    );

    if (quantityInputs.length === 0) return;

    // Override form submission
    form.addEventListener("submit", function (e) {
      // Get the first visible quantity input
      const activeQuantityInput = quantityInputs[0];
      const quantity = parseInt(activeQuantityInput.value) || 1;

      // Remove any existing hidden quantity inputs
      form
        .querySelectorAll('input[type="hidden"][name="quantity"]')
        .forEach((input) => {
          input.remove();
        });

      // Create a new hidden input with the current quantity
      const qtyInput = document.createElement("input");
      qtyInput.type = "hidden";
      qtyInput.name = "quantity";
      qtyInput.value = quantity;

      // Add the hidden input to the form
      form.appendChild(qtyInput);
    });
  });

  // Handle responsive product titles
  function handleResponsiveProductTitles() {
    const productTitles = document.querySelectorAll(
      ".shop-product-title[data-font-size][data-mobile-font-size]"
    );

    productTitles.forEach((title) => {
      function adjustTitleFontSize() {
        const desktopSize = title.getAttribute("data-font-size");
        const mobileSize = title.getAttribute("data-mobile-font-size");

        if (window.innerWidth <= 767) {
          title.style.setProperty("font-size", `${mobileSize}px`, "important");
        } else {
          title.style.setProperty("font-size", `${desktopSize}px`, "important");
        }
      }

      // Run immediately
      adjustTitleFontSize();

      // Add resize event listener if not already added
      if (!title.hasAttribute("data-resize-listener-added")) {
        window.addEventListener("resize", adjustTitleFontSize);
        title.setAttribute("data-resize-listener-added", "true");
      }
    });
  }

  // Initialize responsive product titles
  handleResponsiveProductTitles();

  // Handle FAQ accordions
  function initFaqAccordions() {
    const faqContainers = document.querySelectorAll(".product-faq");

    faqContainers.forEach((faqContainer) => {
      const faqId = faqContainer.id;
      if (!faqId) return;

      const faqItems = faqContainer.querySelectorAll(".faq-item");
      const innerFaqContainer = faqContainer.querySelector(".faq-container");
      const isAccordion =
        innerFaqContainer &&
        innerFaqContainer.getAttribute("data-accordion") === "true";

      faqItems.forEach((item) => {
        const question = item.querySelector(".faq-question");
        if (!question) return;

        // Only add click listener if it doesn't already have one
        if (!question.hasAttribute("data-click-listener-added")) {
          question.setAttribute("data-click-listener-added", "true");

          question.addEventListener("click", () => {
            const isActive = item.classList.contains("active");

            // Close all other items first if accordion mode is enabled
            if (isAccordion && !isActive) {
              faqItems.forEach((otherItem) => {
                otherItem.classList.remove("active");
              });
            }

            // Toggle the clicked item
            item.classList.toggle("active");
          });
        }
      });
    });
  }

  // Initialize FAQ accordions
  initFaqAccordions();

  // UPDATE PRICE WHEN VARIANT CHANGES - NEW CODE
  function updatePriceDisplay(variantId) {
    const variantElement = document.querySelector(
      `[data-selected-variant*="${variantId}"]`
    );
    
    if (variantElement) {
      try {
        const variantData = JSON.parse(variantElement.innerHTML);
        
        // Update price display
        const priceElements = document.querySelectorAll(
          ".shop-product-price-block, .product-price"
        );
        
        priceElements.forEach((priceEl) => {
          if (variantData.price) {
            // Format price properly
            const formattedPrice = (variantData.price / 100).toLocaleString(
              "en-US",
              { minimumFractionDigits: 2, maximumFractionDigits: 2 }
            );
            priceEl.textContent = `$${formattedPrice}`;
          }
        });

        // Update compare price if on sale
        const comparePriceElements = document.querySelectorAll(
          ".shop-compare-price"
        );
        comparePriceElements.forEach((compareEl) => {
          if (variantData.compare_at_price && variantData.compare_at_price > variantData.price) {
            const formattedComparePrice = (
              variantData.compare_at_price / 100
            ).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            compareEl.textContent = `$${formattedComparePrice}`;
            compareEl.style.display = "inline";

            // Update save percentage
            const saveElements = document.querySelectorAll(
              ".shop-save-price"
            );
            saveElements.forEach((saveEl) => {
              const discountPercentage = Math.round(
                ((variantData.compare_at_price - variantData.price) /
                  variantData.compare_at_price) *
                  100
              );
              const saveText = saveEl.textContent.split(" ")[0]; // Get "SAVE" or custom text
              saveEl.textContent = `${saveText} ${discountPercentage}%`;
            });
          } else {
            compareEl.style.display = "none";
          }
        });
      } catch (e) {
        console.error("Error updating price:", e);
      }
    }
  }

  // Listen for variant changes
  document.addEventListener("variant:change", function (e) {
    if (e.detail && e.detail.variant && e.detail.variant.id) {
      updatePriceDisplay(e.detail.variant.id);
    }
  });

  // Also update price when variant input changes
  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="id"]')) {
      const variantId = e.target.value;
      if (variantId) {
        updatePriceDisplay(variantId);
      }
    }
  });
});

// Bundle click handler
document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    document.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
      bar.addEventListener("click", function () {
        // Get pricing values
        const pricingContainer = bar.querySelector(
          ".kaching-bundles__bar-pricing"
        );
        const priceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-price"
        );
        const fullPriceElement = pricingContainer.querySelector(
          ".kaching-bundles__bar-full-price"
        );

        const price = priceElement ? priceElement.textContent.trim() : null;
        const fullPrice = fullPriceElement
          ? fullPriceElement.textContent.trim()
          : null;

        // Find parent product info block
        const productInfo = bar.closest(".shop-product-info");

        if (productInfo && price && fullPrice) {
          const buttonTextContainer = productInfo.querySelector(
            ".shop-add-to-cart-button .button-text"
          );
          if (buttonTextContainer) {
            setTimeout(function () {
              buttonTextContainer.innerHTML = `Add to Cart - ${price} <span class="compare-price">${fullPrice}</span>`;
            }, 50);
          }
        }
      });
    });
  }, 1000);
});